import classNames from 'classnames';
import { ButtonHTMLAttributes } from 'react';
import shareIcon from 'public/static/images/share-icon.svg';

interface ShareIconProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
}

export default function ShareIcon({ className, onClick, ...props }: ShareIconProps): JSX.Element {
  return (
    <>
      <button className={classNames('share-icon-button', className)} onClick={onClick} {...props}>
        <img
          data-testid="share-icon"
          className={classNames('share-icon')}
          src={shareIcon}
          alt="share"
        />
      </button>
      <style jsx>{`
        .share-icon-button {
          position: absolute;
          top: 12px;
          right: 60px;
          z-index: 9;
          background-color: transparent;
          border: none;
          padding: 0;
          margin: 0;
          cursor: pointer;
          height: 40px;
          width: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.6);
          border-radius: 8px;
          box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
        }

        .share-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          height: 24px;
          width: 24px;
          border: none;
        }
      `}</style>
    </>
  );
}
